import T from '../../services/language';
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router";
import {Container, ContainerView} from "../../components/Container";
import {Header} from "../../components/Header";
import orderBy from 'lodash/orderBy';
import {listProductAndService} from "../../services/app";
import {CheckedIcon, Item, ItemImage, ItemInfo, Items, ItemTitle, ListIcon, Title} from "./style";
import {SkeletonViewText} from "../../components/Skeleton";
import {useApp} from "../../contexts/app";
import {Image} from "../../components/Image";
import useSessionCompleted from "../../hooks/completed";


export default function ProductService(props: any) {
    const [rows, setRows] = useState([]);
    const [row, setRow] = useState<any>();
    const [mode, setMode] = useState('grid');
    const navigate = useNavigate();
    const {groupSlug, shareUrlKey, campaignId, customerId, productServiceId, productServiceType, clientCode} = useParams();
    const {campaign} = useApp();
    const [loading, setLoading] = useState(true);
    const sessionCompleted = useSessionCompleted();

    const loadData = async () => {
        setLoading(true);
        const result = await listProductAndService(campaignId);
        if (result.status === 200) {
            const items = result?.data?.data?.items || [];
            const dataSorted = orderBy(items, ['index'])
            setRows(dataSorted);
        }
        setLoading(false);
    };

    useEffect(() => {
        loadData();
    }, []);

    const onNext = (row?: any) => {
        navigate(`/${groupSlug}/${shareUrlKey}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${row?.id}/${row?.pssId||'none'}`)
    }

    return (
        <Container>
            <Header right={(
                <div onClick={() => {
                    setMode(prevState => prevState === 'grid' ? 'list' : 'grid')
                }} style={{opacity: (mode === 'grid' ? 0.7 : 1), marginLeft: 12, height: 24}}>
                    <ListIcon/>
                </div>
            )} title={(<span style={{
                textTransform: 'capitalize',
                display: "flex"
            }}>{productServiceType === 'service' ? T("Service") : T("Product") || ""}</span>)}
                    back={false}/>

            <ContainerView>
                {loading ? (<>
                    <SkeletonViewText itemStyle={{width: "70%", height: 24, marginLeft: 0}} lines={[1]}/>
                    {/*<SkeletonViewText lines={[1, 2]} itemStyle={{height: 13, marginLeft: 0}}/>*/}
                </>) : (
                    <>
                        <Title>{campaign?.name || ""}</Title>
                        {/*<Desc>{campaign?.descriptions || ""}</Desc>*/}
                    </>
                )}

                <Items>
                    {
                        loading ? (
                            <>
                                {[1, 2, 3, 4]?.map((value, index) => {
                                    return (
                                        <Item key={index.toString()}>
                                            <ItemImage className={`${mode}`}>
                                                <Image src={""}/>
                                            </ItemImage>
                                            <ItemInfo className={`${mode}`}>
                                                <ItemTitle>
                                                    <SkeletonViewText itemStyle={{width: "70%", height: 16}}
                                                                      lines={[1]}/>
                                                </ItemTitle>
                                                {/*<ItemDesc>*/}
                                                {/*    <SkeletonViewText lines={[1, 2, 3]} itemStyle={{height: 11}}/>*/}
                                                {/*</ItemDesc>*/}
                                            </ItemInfo>
                                        </Item>
                                    )
                                })}
                            </>
                        ) : null
                    }
                    {rows?.filter(x => x.status === 'active')?.map((value, index) => {
                        return (
                            <Item onClick={() => onNext(value)}
                                  className={`${mode} ${row?.id === value?.id ? 'active' : ''}`}
                                  key={index.toString()}>
                                <ItemImage className={`${mode}`}>
                                    <Image src={value?.thumbnailUrl || "/assets/images/default_service.png"}/>
                                </ItemImage>
                                <ItemInfo className={`${mode}`}>
                                    <ItemTitle>{value?.name || ""}</ItemTitle>
                                    {/*<ItemDesc>{value?.descriptions || ''}</ItemDesc>*/}
                                </ItemInfo>
                                {row?.id === value?.id ? (<CheckedIcon/>) : null}
                            </Item>
                        )
                    })}
                </Items>
                {/* <ContainerViewFooter>
                    <NextButton disabled={!row} onClick={() => {
                        onNext()
                    }}>{T('Next')}</NextButton>
                </ContainerViewFooter> */}

            </ContainerView>
        </Container>
    )
}
